import { render, staticRenderFns } from "./audition-item.vue?vue&type=template&id=3b9fe130&scoped=true"
import script from "./audition-item.vue?vue&type=script&lang=js"
export * from "./audition-item.vue?vue&type=script&lang=js"
import style0 from "./audition-item.vue?vue&type=style&index=0&id=3b9fe130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9fe130",
  null
  
)

export default component.exports